import * as React from 'react';
import "./index.css";
import {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {RoutePath} from "../../../../../constants/RoutePath";
import {UserApi} from "../../../../../modules/account/api/UserApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {UserDto} from "../../../../../modules/account/dto/UserDto";
import {Button} from "@mui/material";
import {FormattedMessage, useIntl} from "react-intl";
import HomeIcon from "@mui/icons-material/Home";
import NavigationBar from "../../../../../components/NavigationBar";
import {HttpUtils} from "../../../../../utils/HttpUtils";
import {AuthType} from "../../../../../modules/account/enums/AuthType";
import {WECHAT_APP_ID, WECHAT_AUTH_DOMAIN, WECHAT_AUTH_PAGE} from "../../../../../constants/Profile";
import {AccountCacheKey} from "../../../../../modules/account/constants/AccountCacheKey";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import PasswordDialog from "../../../../account/user/security/components/PasswordDialog";

export default function Index() {
    const intl = useIntl();
    const navigate = useNavigate();

    const [currentUser, setCurrentUser] = useState(new UserDto());

    // 密码修改对话框
    const [openPasswordDialog, setOpenPasswordDialog] = useState(false);

    useEffect(() => {
        // 微信网页授权会携带code，然后通过后台获取openID，提交的时候把该openID跟访客绑定
        const wxOAuthCode = HttpUtils.getQueryString(window.location.href, "wxOAuthCode");
        if (wxOAuthCode) {
            _loginByWeChatAuthCode(wxOAuthCode);
        } else {
            _handleGetSessionUser();
        }
    }, []);

    const _handleGetSessionUser = async () => {
        const responseResult = await UserApi.getSessionUser();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            const sessionUser = responseResult.data;
            if (!sessionUser.passwordModifyTime) {
                // 如果密码未修改过，则弹框提示修改密码
                MessageUtils.warning(intl.formatMessage({id:'ACCOUNT_USER_PASSWORD_INITIAL_MODIFY_REQUIRED'}));
                setOpenPasswordDialog(true);
            }

            setCurrentUser(sessionUser);
        }
    }

    const _loginByWeChatAuthCode = async (wxOAuthCode: string) => {
        const responseResult = await UserApi.login(new UserDto(), AuthType.Enum.WeChatOAuth, wxOAuthCode);
        console.log(responseResult);
        if (responseResult.status === HttpStatus.SUCCESS) {
            console.log(localStorage.getItem(AccountCacheKey.ACCESS_TOKEN));
            _handleGetSessionUser();
        } else if (responseResult.message === "ACCOUNT_USER_NOT_FOUND") {
            const redirectUri = encodeURIComponent(WECHAT_AUTH_DOMAIN + "/" + WECHAT_AUTH_PAGE);
            const state = encodeURIComponent(RoutePath.VMS_MOBILE_EMPLOYEE_LOGIN);
            // navigate(RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER)
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + WECHAT_APP_ID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
        }
    }

    const _handleNavigate = (path: string) => {
        console.log(navigate);
        navigate(path);
    }

    return (
        <div className={"mobile-employee-home-background"}>

            <PasswordDialog open={openPasswordDialog} onClose={() => setOpenPasswordDialog(false)}/>
            
            <NavigationBar leftIcon={<HomeIcon/>}
                           leftIconClick={() => navigate(RoutePath.VMS_MOBILE_WELCOME)}
                           title={intl.formatMessage({id: "VMS_MOBILE_WELCOME_SELF_EMPLOYEE_ENTRANCE"})}/>

            {/*头部区域*/}
            <div className={"mobile-employee-home-header"}>
                <div className={"mobile-employee-home-header-title"}>
                    {currentUser.fullName}
                </div>
            </div>

            {/*操作区域内容*/}
            <div className="mobile-employee-home-operation-panel">
                <div className={"mobile-employee-home-operation-main"}>
                    <Button variant="contained" fullWidth={true}
                            onClick={() => _handleNavigate(RoutePath.VMS_MOBILE_EMPLOYEE_APPROVE)}>
                        <FormattedMessage id='VMS_VISIT_REQUEST_PENDING_APPROVAL_LIST'/>
                    </Button>
                    <Button variant="contained" fullWidth={true}
                            onClick={() => _handleNavigate(RoutePath.VMS_MOBILE_EMPLOYEE_HISTORY)}>
                        <FormattedMessage id='VMS_REQUEST_VISITOR_HISTORY_LIST'/>
                    </Button>
                </div>
            </div>
        </div>
    )
}